export const getWallDir = (gymId, wallId) => {
  return 'gyms/' + gymId + '/walls/' + wallId
}

export const gymsPath = '/gyms'
export const gymPath = gymId => {
  return gymsPath + '/' + gymId
}

export const wallPath = (gymId, wallId) => {
  return gymsPath + '/' + gymId + '/walls/' + wallId
}

export const editWallPath = (gymId, wallId) => {
  return wallPath(gymId, wallId) + '/edit'
}

export const problemPath = problem => {
  return wallPath(problem.gymId, problem.wallId) + '/problems/' + problem.key
}



// WEBPACK FOOTER //
// ./src/helpers/urlHelpers.js